import get from 'lodash/get';
import merge from 'lodash/merge';
import { IMember } from '../../../members/types';
import { coreMemberSerializer } from './coreMember.serializer';
import {
  EIncludedType,
  IApiMemberProfile,
  IApiMemberProfileAttributes,
  IRelationships,
  TApiIncluded,
} from './member.types';

const filterMemberIncluded = (
  included: TApiIncluded,
  relationships: IRelationships
) =>
  included.filter(
    includedItem =>
      get(relationships, `[${includedItem.type}].data.id`) === includedItem.id
  );

const computeIncludedAttributes = (
  included: TApiIncluded,
  coreMember: IMember,
  relationships: IRelationships
): IMember => {
  const memberIncluded = filterMemberIncluded(included, relationships);

  return memberIncluded.reduce((acc, includedItem) => {
    switch (includedItem.type) {
      case EIncludedType.ANNOUNCE:
        return merge(acc, {
          profile: {
            announce: {
              text: includedItem.attributes.text,
              isValid: includedItem.attributes.valid,
            },
          },
        });
      case EIncludedType.BLACKLIST:
        return merge(acc, {
          attributes: {
            isBlacklisted: includedItem.attributes.isBlacklisted,
          },
        });
      case EIncludedType.FAVORITE:
        return merge(acc, {
          profile: {
            isFavorite: true,
          },
        });
      case EIncludedType.PHOTO_REVEAL_STATUS:
        return merge(acc, {
          profile: {
            photoRevealStatus: includedItem.attributes.value,
          },
        });
      case EIncludedType.LAST_CONNECTION:
        return merge(acc, {
          profile: {
            lastConnectionDate: includedItem.attributes.last_connection_date,
          },
        });
      default:
        return acc;
    }
  }, coreMember);
};

export const memberProfileSerializer = (
  member: IApiMemberProfileAttributes,
  apiMemberProfile: IApiMemberProfile
): IMember => {
  const coreMember = coreMemberSerializer(member);

  if (!apiMemberProfile.included) return coreMember;

  if (!member.relationships) return coreMember;

  return computeIncludedAttributes(
    apiMemberProfile.included,
    coreMember,
    member.relationships
  );
};
